import builder from '../builder';
import LayoutModule from '../../streamline-icons/bold/layout-module.svg';

export default builder('IconLayoutModuleBold', LayoutModule);
